import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const NameIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M5.062 7.823v.923h13.877v-.923H5.062Zm2.515 3.723v.923h8.846v-.923H7.577Zm0 3.708v.923h3.908v-.923H7.577ZM4.138 5.672c0-.429.149-.792.446-1.089a1.48 1.48 0 0 1 1.088-.445h12.656c.429 0 .792.149 1.088.445.297.297.446.66.446 1.09v12.655c0 .429-.149.792-.445 1.088a1.48 1.48 0 0 1-1.09.445H5.673a1.48 1.48 0 0 1-1.088-.445 1.48 1.48 0 0 1-.446-1.088V5.672Zm.924.005v12.646c0 .154.064.295.192.423s.27.192.423.192h12.646a.588.588 0 0 0 .423-.192.588.588 0 0 0 .193-.423V5.677a.588.588 0 0 0-.193-.423.588.588 0 0 0-.423-.192H5.677a.588.588 0 0 0-.423.192.588.588 0 0 0-.192.423Z"
    />
  </Svg>
)
export default NameIcon
